import {HttpClient} from "../../service/httpClient/HttpClient";

export class LoanRequestsService {
    constructor() {
        this.httpClient = new HttpClient()
    }


    getPendingAmount(fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/loans/requests/statistics`
            ).then(resolve).catch(reject)
        })
    }

    getLoanRequests(fundID, page, size, fullName, accountCode, startDate, endDate,sortTypes) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/loans/requests`,
                {
                    page,
                    size,
                    "full-name": fullName ? fullName : null,
                    "start-send-at": startDate ? startDate : null,
                    "end-send-at": endDate ? endDate : null,
                    "deposit-account-number": accountCode ? accountCode : null,
                    "sort_by":sortTypes
                }
            ).then(resolve).catch(reject)
        })
    }

    getLoanRequestBasicInfo(fundID, loanRequestId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/funds/${fundID}/loans/requests/${loanRequestId}`
            ).then(resolve).catch(reject)
        })
    }

    getLoanRequestInstallments(fundID, loanRequestId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/loans/requests/${loanRequestId}/pre-create`
            ).then(resolve).catch(reject)
        })
    }

    rejectLoanRequest(fundID, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/loans/requests/${id}/rejected`
            ).then(resolve).catch(reject)
        })
    }

    acceptLoanRequest(fundID, requestId, type, amount, installments, payDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/loans/requests/${requestId}/accepted`,
                {
                    acceptedAmount: amount,
                    acceptedNumberOfInstallments: installments,
                    acceptedLoanKindId: type,
                    grantDate: payDate,
                }
            ).then(resolve).catch(reject)
        })
    }
}